import type { FormInstance } from 'antd';
import { useMemo } from 'react';

import type { ExperienceResponse } from 'app/typings/core/admin/experiences/experience';
import type { PackExperienceResponse } from 'app/typings/core/admin/packs/pack';

type UseExperienceListLogicProps = {
  experiences?: ExperienceResponse[];
  form: FormInstance;
};

export const useExperienceListLogic = ({
  experiences,
  form,
}: UseExperienceListLogicProps) => {
  const { otherExperiences } = useMemo(() => {
    return (
      experiences?.reduce(
        (
          acc: {
            otherExperiences: ExperienceResponse[];
          },
          exp
        ) => {
          if (!exp.isAlwaysIncludedWithNight) {
            acc.otherExperiences.push(exp);
          }

          return acc;
        },
        { otherExperiences: [] }
      ) ?? { otherExperiences: [] }
    );
  }, [experiences]);

  const createToggleExperienceHandler = (experience: ExperienceResponse) => {
    return (value: boolean) => {
      const current: PackExperienceResponse[] =
        form.getFieldValue('packExperiences') || [];

      const index = current.findIndex(
        (exp) => exp.experienceId === experience.id
      );

      let next;

      if (index >= 0) {
        next = current.map((exp) =>
          exp.experienceId === experience.id ? { ...exp, discover: value } : exp
        );
      } else {
        next = [
          ...current,
          {
            experienceId: experience.id,
            discover: value,
          },
        ];
      }

      form.setFieldsValue({
        packExperiences: next,
      });
      form.validateFields();
    };
  };

  return {
    otherExperiences,
    createToggleExperienceHandler,
  };
};
